import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiCheck } = FiIcons;

const FinalCTA = ({ onBookPilot }) => {
  return (
    <section className="py-16 lg:py-24 gradient-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="font-display font-bold text-4xl lg:text-6xl text-white mb-6">
              Ready to hire faster — without sacrificing fairness?
            </h2>
            <p className="text-xl text-slate-300 mb-12 max-w-4xl mx-auto leading-relaxed">
              Start a free pilot and see live shortlisting in your workflow. 
              No commitment, no credit card required.
            </p>
          </motion.div>

          <motion.div
            className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <motion.button
              onClick={onBookPilot}
              className="gradient-gold text-slate-900 font-semibold px-12 py-5 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center space-x-3 text-lg"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <span>Book Free Pilot</span>
              <SafeIcon icon={FiArrowRight} className="w-6 h-6" />
            </motion.button>

            <div className="text-slate-300 text-center sm:text-left">
              <div className="text-sm">🚀 Setup in 24 hours</div>
              <div className="text-sm">✨ Full feature access</div>
              <div className="text-sm">🎯 Dedicated onboarding</div>
            </div>
          </motion.div>

          <motion.div
            className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            {[
              { number: '14 days', label: 'Free pilot period' },
              { number: '< 24hrs', label: 'Average setup time' },
              { number: '10x', label: 'Faster hiring process' }
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl lg:text-4xl font-bold text-white mb-2">
                  {stat.number}
                </div>
                <div className="text-slate-300">
                  {stat.label}
                </div>
              </div>
            ))}
          </motion.div>

          <motion.div
            className="mt-12 text-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            viewport={{ once: true }}
          >
            <p className="text-slate-400 text-sm">
              Join 500+ companies already hiring smarter with Instashortlist
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;